import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { LensDownstreamOwnersQueryVariables, LensDownstreamOwnersQuery, OwnersDisplayGridRowDataFragment, TableauUserSortOrder , LensDownstreamOwnersDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper,
  SelectionProviderChildProps
} from '../../../data-catalog-shared';
import { OwnersDisplayGrid, OwnersDisplayGridRowData } from '../sharedDisplayGrid/OwnersDisplayGrid';
import { OwnersValidSortFields } from '../sorting/sortProviders/OwnersGridSortProvider';

type QueryVariables = LensDownstreamOwnersQueryVariables;
type QueryResults = LensDownstreamOwnersQuery;
type QueryResultListNode = OwnersDisplayGridRowDataFragment;
type GridRowData = OwnersDisplayGridRowData;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData?.lenses && resultData.lenses[0] &&
    resultData.lenses[0].downstreamOwnersConnection;
}

function mapResultNode(node: QueryResultListNode): GridRowData {
  return {
    id: node.vizportalId,
    name: node.name,
    username: node.username,
    domain: node.domain,
    workbookCount: node.ownedWorkbooksConnection ? node.ownedWorkbooksConnection.totalCount : null,
    datasourceCount: node.ownedDatasourcesConnection ? node.ownedDatasourcesConnection.totalCount : null,
    metricsCount: node.ownedMetricsConnection ? node.ownedMetricsConnection.totalCount : null,
    virtualConnectionsCount: node.ownedVirtualConnectionsConnection ? node.ownedVirtualConnectionsConnection.totalCount : null
  };
}

export type LensDownstreamOwnersQueryGridProps =
  SelectionProviderChildProps &
  GridSortProps<OwnersValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly rowCount: number | null;
  };

export function LensDownstreamOwnersQueryGrid(props: LensDownstreamOwnersQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamOwnersLineageGridMessage();

  return <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
    queryGql={LensDownstreamOwnersDocument}
    partialQueryVariables={{ vizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy as TableauUserSortOrder }}
    selectConnectionListResult={selectConnectionListResult}
    mapResultNode={mapResultNode}
  >
    {({ rowStore }) => (
      <OwnersDisplayGrid
        rowStore={rowStore}
        selectedKeys={props.selectedKeys}
        updateSelectionForKey={props.updateSelectionForKey}
        emptyGridMessage={emptyGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />
    )}
  </PaginatedQueryWrapper>;
}
